import * as React from "react";
import { createStyles, Grid, Theme, withStyles } from "@material-ui/core";
import Logo from "./Logo";
import SearchSection from "./search/SearchSection";

const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginLeft: spacing(16),
      marginRight: spacing(16),
    },
  });

const Page = (props: any) => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <Grid container spacing={3} justifyContent="center" alignItems="stretch">
        <Logo />
        <SearchSection />
      </Grid>
    </div>
  );
};

export default withStyles(styles)(Page);
